import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';
import { notify } from 'src/components/notify';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });
axiosInstance.interceptors.request.use((req) => {


  return req

}, (err) => err)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Axios Error:", error);

    if (error?.response?.data) {
      // Show notification
      notify(error.response.data.message || error.response.data || "An error occurred");

      // Still reject so that calling function can handle it
      return Promise.reject(error.response.data);
    }

    // Handle network errors or unexpected issues
    notify("Something went wrong. Please try again.");
    return Promise.reject(error.message || "Something went wrong");
  }
);

export default axiosInstance;